import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;


const HomeSectionService = {
  getList: async () => {
    const response = await apiService.get("/homesections");
    console.log("called home")
    return response.data;
  },

  getbyId: async (id) => {
    const response = await apiService.get(`/testpreparations/${id}`);
    return response.data;
  },
};

export default HomeSectionService;
